export default "__VITE_ASSET__CfrJVIoj__ 1200w";